/**
 * Module qui défini les variables globales d'informations de l'appareil et d'affichage utilisant UAParser.
 */
export default class FF_Device_Data {

  /**
   * @constructor
   */
  constructor() {

    this.ua_parser = new UAParser();
    this.ua_parser_results = this.ua_parser.getResult();
    this.define_global_vars();

    // Met l'écouteur au redimmensionnement de la fenêtre qui va mettre à jour les variables d'affichage.
    $(window).on('resize', this.update_display_vars);

  }

  /**
   * Met en place les variable globales.
   */
  define_global_vars() {

    // ======================================================================
    // Variables de données d'appareils
    // ======================================================================
    window.is_mobile = typeof this.ua_parser_results.device.type !== 'undefined' && (this.ua_parser_results.device.type === 'mobile' || this.ua_parser_results.device.type === 'tablet');
    window.is_tablet = this.ua_parser_results.device.type == 'tablet';
    window.is_phone = this.ua_parser_results.device.type == 'mobile';
    window.browser = this.ua_parser_results.browser.name;
    window.browser_version = this.ua_parser_results.browser.version;
    window.platform = (this.ua_parser_results.device.vendor ? this.ua_parser_results.device.vendor : this.ua_parser_results.os.name);
    window.operating_system = this.ua_parser_results.os.name;
    window.operating_system_version = this.ua_parser_results.os.version;
    window.is_touch_device = typeof ScrollTrigger !== 'undefined' ? ScrollTrigger.isTouch != 0 : window.matchMedia('(pointer: coarse)').matches;
    window.is_pointer_device = window.matchMedia('(pointer: fine)').matches;

    // Vérification pour les appareils iOS >=13
    if ((navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) && !window.MSStream) is_mobile = true;

    // Détection pour le navigateur Silk de FireOS
    if (navigator.userAgent.indexOf('Silk') >= 0) {
      browser = 'Silk';
    }

    // Ajout des informations en tant qu'attributs l'élément <html>
    $('html').attr({
      'data-browser'        : browser,
      'data-browser-version': browser_version,
      'data-platform'       : platform,
      'data-os'             : operating_system,
      'data-os-version'     : operating_system_version
    });

    // Ajout des informations du type d'appareil en tant que classes à l'élément <html>
    const html_classes = [
      (is_mobile ? 'is-mobile' : 'is-desktop'),
      (is_tablet ? 'is-tablet' : ''),
      (is_phone ? 'is-phone' : ''),
      (is_touch_device ? 'is-touch-device' : ''),
      (is_pointer_device ? 'is-pointer-device' : '')
    ].filter(Boolean); // *Filter pour retirer les éléments vides du tableau
    $('html').addClass(html_classes);

    // ======================================================================
    // Variables d'affichage
    // ======================================================================
    this.update_display_vars();

  }

  /**
   * Met à jour les variables d'affichage.
   */
  update_display_vars() {
    if (typeof media_queries === 'undefined') return;
    window.is_desktop_display = window.matchMedia(media_queries.desktop_only).matches; // Variable qui indique si la page affiche les styles de bureau (selon des média queries de CSS)
    window.is_tablet_display = window.matchMedia(media_queries.tablet_only).matches; // Variable qui indique si la page affiche les styles de tablettes (selon des média queries de CSS)
    window.is_laptop_display = window.matchMedia(media_queries.laptop_and_down).matches; // Variable qui indique si la page affiche les styles de laptop (selon des média queries de CSS)
    window.is_small_tablet_display = window.matchMedia(media_queries.small_tablet_and_down).matches; // Variable qui indique si la page affiche les styles de petite tablette (selon des média queries de CSS)
    window.is_phone_display = window.matchMedia(media_queries.phone_only).matches; // Variable qui indique si la page affiche les styles de mobile (selon des média queries de CSS)
  }

}
